var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9998 0.800781C8.49687 0.800781 8.89981 1.10962 8.89981 2.60078V7.10078H13.3998C14.891 7.10078 15.1998 7.50372 15.1998 8.00078C15.1998 8.49785 14.891 8.90078 13.3998 8.90078H8.89981V13.4008C8.89981 14.892 8.49687 15.2008 7.9998 15.2008C7.50274 15.2008 7.0998 14.892 7.0998 13.4008V8.90078H2.5998C1.10864 8.90078 0.799805 8.49785 0.799805 8.00078C0.799805 7.50372 1.10864 7.10078 2.5998 7.10078H7.0998V2.60078C7.0998 1.10962 7.50274 0.800781 7.9998 0.800781Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus_icon.e34563fd47ba24119de625f1ecf2e701.svg";
export { ForwardRef as ReactComponent };